import { Checkmark, Copy } from '@carbon/icons-react';
import * as React from 'react';
import { Input, InputButton } from 'vet-bones/design-system/components';
import { copyToClipboard } from 'vet-bones/utils';

interface CopyableInputProps {
  buttonTestId?: string;
  inputTestId?: string;
  label: string;
  value: string;
}
export const CopyableInput: React.VFC<CopyableInputProps> = ({
  buttonTestId,
  inputTestId,
  label,
  value,
}) => {
  const [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = () => {
    copyToClipboard(value);
    setCopied(true);
  };

  return (
    <Input
      clearable={false}
      label={label}
      readOnly
      rightElement={
        <InputButton
          icon={copied ? Checkmark : Copy}
          onClick={handleCopy}
          testId={buttonTestId}
        />
      }
      size="md"
      testId={inputTestId}
      value={value}
    />
  );
};
